module.exports = __webpack_public_path__ + "1827417f950d50ad9b7d988e5c783b55.MP3";